import { __decorate } from "tslib";
import React, { Component } from 'react';
import { action, get, set } from 'mobx';
import { observer } from 'mobx-react';
import { pxToRem } from '../../../lib/_util/UnitConvertor';
import ResizeObservedRow from './ResizeObservedRow';
import TableContext from './TableContext';
import autobind from '../_util/autobind';
import { isStickySupport } from './utils';
let TableHeaderRow = class TableHeaderRow extends Component {
    handleResize(rowIndex, height) {
        this.setRowHeight(rowIndex, height);
    }
    setRowHeight(index, height) {
        const { tableStore } = this.context;
        set(tableStore.lockColumnsHeadRowsHeight, index, height);
    }
    getRowHeight(index) {
        const { tableStore } = this.context;
        return get(tableStore.lockColumnsHeadRowsHeight, index) || 0;
    }
    getHeaderRowStyle(rows, rowIndex) {
        const height = this.getRowHeight(rowIndex++);
        return pxToRem(rows
            .slice(rowIndex)
            .reduce((total, r, index) => r.length
            ? total
            : total +
                this.getRowHeight(index + rowIndex), height));
    }
    render() {
        const { rowIndex, lock, tds, rows } = this.props;
        const { tableStore: { rowHeight }, } = this.context;
        const needStoreRowHeight = !isStickySupport() && (rowHeight === 'auto' || rows.length > 1);
        const tr = (React.createElement("tr", { style: {
                height: lock && needStoreRowHeight ? this.getHeaderRowStyle(rows, rowIndex) : undefined,
            } }, tds));
        return !lock && needStoreRowHeight ? (React.createElement(ResizeObservedRow, { onResize: this.handleResize, rowIndex: rowIndex }, tr)) : tr;
    }
};
TableHeaderRow.contextType = TableContext;
__decorate([
    autobind
], TableHeaderRow.prototype, "handleResize", null);
__decorate([
    action
], TableHeaderRow.prototype, "setRowHeight", null);
TableHeaderRow = __decorate([
    observer
], TableHeaderRow);
export default TableHeaderRow;
;
